import { useDispatch } from "react-redux";
import { receiveBioData, receiveProfileData, requestProfileData } from "./actions";

export default function useProfileActions() {
	const dispatch = useDispatch();

	const onRequestProfileData = () => {
		dispatch(requestProfileData());
	};

	const onReceiveProfileData = () => {
		dispatch(receiveProfileData());
	};

	const onReceiveBioData = () => {
		dispatch(receiveBioData());
	};

	return {
		onReceiveProfileData,
		onRequestProfileData,
		onReceiveBioData
	};
}
